export default __webpack_public_path__ + "static/media/paytm_logo.61395eed.webp";